import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { Table } from "../../../../../../Shared/Table/Table";
import { InvestmentsAction} from "../../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";

interface IAssetsToSellTableProps {
    existingData: InvestmentAllocation[];
    instructionData: InvestmentAllocation[];
    title?: string;
}

interface IAssetsToSellTableState {
    assetDetails: Instrument[]
}

export class AssetsToSellTable extends FormComponent<IAssetsToSellTableProps, IAssetsToSellTableState> {
    constructor(props: any) {
        super(props);
        this.state = {
            assetDetails: []
        };
    }

    componentDidMount() {
        this.getAssetDetails()
    }

    private getAssetDetails() {
        const { existingData, instructionData } = this.props;

        if (existingData.length > 0 || instructionData.length > 0) {
            let ids = existingData.map((ele) => ele.ProductId);
            ids = ids.concat(instructionData.filter(x => !existingData.some(y => y.ProductId = x.ProductId)).map((ele) => ele.ProductId));

            const params = getQueryParameters();
            var hierarchyId = params["hierarchyid"];
            InvestmentsAction.getAssetDetails(ids, hierarchyId, (result) => {
                this.setState({ assetDetails: result })
            })
        }
    }

    public render(): JSX.Element {
        const { existingData, instructionData, title } = this.props;
        
        const totalForExisting = existingData
            ? existingData.reduce((sum, curr) => {
                  return (sum = sum + curr.Percentage);
              }, 0)
            : [];

        const totalForNewSelect = instructionData
            ? instructionData.reduce((sum, curr) => {
                  return (sum = sum + curr.Percentage);
              }, 0)
            : [];

        return (
            <>
                <h2 className="mt-48">{title || "Disinvest selection"}</h2>
                <h3>Before</h3>
                {existingData.length > 0 ?
                    <Table
                        data={instructionData}
                        col={[
                            {
                                title: "Investments",
                                key: "Name",
                                render: (data, row, index) => {
                                    const productName = this.state.assetDetails.find(x => x.ProductId == row.ProductId)?.Name ?? ""
                                    return <a className="hyper-link">{productName}</a>;
                                },
                            },
                            {
                                title: "Existing allocation",
                                key: "Percentage"
                            }
                        ]}
                        TotalBody={[
                            { data: "Total", colSpan: 1 },
                            { data: <span className={totalForExisting == 100 ? "text-positive" : "text-text"}>{totalForExisting}%</span> },
                        ]}
                    /> : 
                    <div><p>Proportional</p></div>
                }
                <h3>After</h3>
                {instructionData.length > 0 ?
                    <Table
                        data={instructionData}
                        col={[
                            {
                                title: "Investments",
                                key: "Name",
                                render: (data, row, index) => {
                                    const productName = this.state.assetDetails.find(x => x.ProductId == row.ProductId)?.Name ?? ""
                                    return <a className="hyper-link">{productName}</a>;
                                },
                            },
                            {
                                title: "New allocation",
                                key: "Percentage",
                            },
                        ]}
                        TotalBody={[
                            { data: "Total", colSpan: 1 },
                            { data: <span className={totalForNewSelect == 100 ? "text-positive" : "text-text"}>{totalForNewSelect}%</span> },
                        ]}
                    /> :
                    <div><p>Proportional</p></div>
                }
            </>
        );
    }
}
